import { useEffect } from 'react';
import WithLoadingSpinner from '../../components/withLoadingSpinner/WithLoadingSpinner';
import OohMap from './components/map/OohMap';
import { useOohUrlParams } from '../../core/hooks/ooh/useOohUrlParams';
import { useOohData } from '../../core/hooks/ooh/useOohData';
import { useOohState } from '../../core/hooks/ooh/useOohState';
import OohControlsSection from './components/controls/OohControlsSection';
import OohContentSection from './components/content/OohContentSection';
import useAgenciesDataStore from '../../core/hooks/useAgenciesDataStore';
import useOohRoutesDataStore from '../../core/hooks/useOohRoutesDataStore';

const OohComponent = () => {
  const {
    dateParamValue,
    agencyParamValue,
    routeParamValue,
    handleAgencyChanged,
    handleRouteChanged,
    handleDateChanged,
  } = useOohUrlParams();

  const { selectedCourier, handleCourierCardClick, resetSelectedCourier } = useOohState();

  useEffect(() => {
    resetSelectedCourier();
  }, [dateParamValue, agencyParamValue, routeParamValue, resetSelectedCourier]);

  const { areAgenciesLoading } = useAgenciesDataStore();
  const { areOohRoutesLoading } = useOohRoutesDataStore(
    dateParamValue,
    agencyParamValue,
  );

  const {
    oohRoutes,
    courierTrips,
    selectedAgency,
    selectedRoute,
    liveTrackingCoordinates,
    areCourierTripsLoading,
  } = useOohData(
    dateParamValue,
    agencyParamValue,
    routeParamValue,
    selectedCourier,
  );

  const isLoading = areAgenciesLoading || areOohRoutesLoading;

  return (
    <WithLoadingSpinner isLoading={isLoading}>
      <div className="h-full w-8/12 overflow-y-auto px-4 pt-2 pb-4">
        <OohControlsSection
          dateParamValue={dateParamValue}
          agencyParamValue={agencyParamValue}
          routeParamValue={routeParamValue}
          onDateChanged={handleDateChanged}
          onAgencyChanged={handleAgencyChanged}
          onRouteChanged={handleRouteChanged}
        />

        <OohContentSection
          selectedRoute={selectedRoute}
          courierTrips={courierTrips}
          areCourierTripsLoading={areCourierTripsLoading}
          selectedCourier={selectedCourier}
          onCourierCardClick={handleCourierCardClick}
        />
      </div>

      <div className="h-full w-7/12">
        <div className="flex-grow-1" style={{ width: '100%', height: '100%' }}>
          <OohMap
            oohRoutes={oohRoutes}
            agency={selectedAgency}
            liveTrackingCoordinates={liveTrackingCoordinates}
          />
        </div>
      </div>
    </WithLoadingSpinner>
  );
};

export default OohComponent;
